export const GET_EQUIPMENT = 'GET_EQUIPMENT';
export const LOADING_EQUIPMENT = 'LOADING_EQUIPMENT';
export const SAVE_LOADER_EQUIPMENT = 'SAVE_LOADER_EQUIPMENT';
